import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import { ACTIVE_LANGUAGES } from "@/config/markets";

// Only the languages of the active markets are exposed (see config/markets.js).
// All translation resources stay loaded so a market can be switched back on
// without touching this file.
export const SUPPORTED_LANGUAGES = ACTIVE_LANGUAGES;

// Strip unsupported `?lang=` querystring values BEFORE LanguageDetector runs.
// Without this, an unsupported lang (e.g. `?lang=zh`) makes the detector skip
// that source and fall through to navigator.language, producing surprising
// results (e.g. EN for an EN browser when spec says fallback should be FR).
try {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const requested = params.get("lang");
    if (requested && !SUPPORTED_LANGUAGES.includes(requested)) {
      params.delete("lang");
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : "") +
        window.location.hash;
      window.history.replaceState(null, "", newUrl);
    }
  }
} catch (err) {
  console.debug("i18n lang querystring sanitize failed", err);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
    },
    fallbackLng: SUPPORTED_LANGUAGES[0] || "fr",
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
    detection: {
      // Priority: explicit user choice (?lang=) → previous session (localStorage)
      // → browser navigator.languages → en fallback.
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "lf_lang",
      caches: ["localStorage"],
    },
  })
  .then(() => {
    try { document.documentElement.lang = i18n.language || "en"; } catch (err) { console.debug("set html lang failed (init)", err); }
  });

i18n.on("languageChanged", (lng) => {
  try { document.documentElement.lang = lng; } catch (err) { console.debug("set html lang failed (change)", err); }
});

export default i18n;
